import { Box, Tag } from '@factorialco/deprecated-design-system'

import { useTrainingMemberships } from 'modules/trainings/hooks/TrainingMemberships/useTrainingMemberships'
import { useTrainingsDatatable } from 'modules/trainings/hooks/useTrainingsDatatable'

interface Props {
  trainingId: number
  accessId: number
}

export const AttendanceTag = ({ trainingId, accessId }: Props) => {
  const { getTrainingAttendanceColor, getTrainingAttendanceTranslation } = useTrainingsDatatable()

  const { trainingMemberships } = useTrainingMemberships({
    trainingId: Number(trainingId),
    accessId: Number(accessId),
  })

  const trainingMembership = trainingMemberships.find(
    (membership) => membership.accessId === Number(accessId)
  )

  if (!trainingMembership) return null

  return (
    <Box width="fit-content">
      <Tag
        leftItem="circle"
        showCircle
        type={getTrainingAttendanceColor(trainingMembership.status)}
      >
        {getTrainingAttendanceTranslation(trainingMembership.status)}
      </Tag>
    </Box>
  )
}
